<template>
  <div>
    <v-row v-if="tableDisplay == 'permissions'">
      <v-col cols="12" style="margin-top: -80px">
        <v-row>
          <v-col cols="12" class="text-right">
            <v-btn
              color="primary"
              dark
              rounded
              small
              class="mx-2"
              @click="permissionDialog = true"
            >
              Create Permission
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12">
        <v-row class="mb-4 px-3 mt-n2" v-if="selected.length > 0">
          <v-app-bar color="grey darken-3" dense dark>
            <v-toolbar-title class="overline"
              >{{ selected.length }} selected</v-toolbar-title
            >
            <v-divider class="mx-4" vertical></v-divider>
            <v-btn
              depressed
              class="overline mx-4 custom-hover"
              color="grey darken-3"
              @click="editItem()"
              >Update</v-btn
            >
            <v-btn
              depressed
              class="overline mx-4 custom-hover"
              color="grey darken-3"
              @click="deleteItem()"
              >Delete</v-btn
            >
          </v-app-bar>
        </v-row>
      </v-col>
      <v-col cols="12" class="mt-n8" v-show="showSuccessMessage">
        <v-alert dense text type="success" dismissible
          >Created new Permission</v-alert
        >
      </v-col>
      <v-col cols="12" class="mt-n8" v-show="showSuccess">
        <v-alert dense text type="success" dismissible
          >Updated Permission</v-alert
        >
      </v-col>
      <v-col>
        <v-data-table
          show-select
          v-model="selected"
          :single-select="false"
          :headers="headers"
          :items="allPermissions"
          :items-per-page="10"
          class="elevation-2 mt-n6"
          item-key="id"
          :search="search"
          :loading="isFetching"
          loading-text="Loading... Please wait"
        >
          <!-- <template v-slot:[`item.actions`]="{ item }">
          <v-icon small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
          <v-icon small @click="deleteItem(item.id)">mdi-delete</v-icon>
        </template> -->
        </v-data-table>
      </v-col>
      <v-dialog v-model="dialog" persistent max-width="600px">
        <v-card>
          <v-card-title>
            <span class="headline">Update Details</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    aria-autocomplete="off"
                    label="Name*"
                    v-model="editedItem.name"
                    required
                    hint="Make sure it's easy to remember"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    aria-autocomplete="off"
                    label="Description*"
                    v-model="editedItem.description"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" v-if="errorMessage">
                  <h3 class="text-center red--text">{{ errorMessage }}</h3>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="dialog = false"
              >Close</v-btn
            >
            <v-btn color="blue darken-1" text @click="save" :disabled="disableSave">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-snackbar v-model="snackbar" :timeout="timeout">
        "Must select only one user permission to update details"
        <template v-slot:action="{ attrs }">
          <v-btn color="blue" text v-bind="attrs" @click="snackbar = false">
            Close
          </v-btn>
        </template>
      </v-snackbar>
      <PermissionModal :dialog="permissionDialog" @closeDialog="closePermissionDialog"/>
      <loading-overlay v-if="loading"/>
    </v-row>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import PermissionModal from "../PermissionCreateModal";
import Swal from "sweetalert2";
import LoadingOverlay from "../common/LoadingOverlay.vue";

export default {
  name: "Permissions",
  props: {
    tableDisplay: String,
    search: String,
  },
  components: {
    PermissionModal,
    LoadingOverlay
  },
  data() {
    return {
      disableSave: false,
      isFetching: false,
      loading: false,
      permissionDialog: false,
      dialog: false,
      showSuccessMessage: false,
      showSuccess: false,
      singleSelect: false,
      errorMessage: null,
      selected: [],
      headers: [
        {
          text: "Name",
          align: "start",
          sortable: true,
          value: "name",
        },
        { text: "Description", value: "description" },
        { text: "Date Created", value: "date" },
        // { text: "Actions", value: "actions", sortable: false },
      ],
      editedIndex: -1,
      editedItem: {
        name: "",
        description: "",
      },
      defaultItem: {
        name: "",
        description: "",
      },
      options: {
        page: 1,
        itemsPerPage: 5,
      },
      selectedPermission: null,
      snackbar: false,
      timeout: 5000,
      fetchOnce: true
    };
  },
  methods: {
    ...mapActions(["fetchPermissions", "updatePermission", "deletePermission"]),
    closePermissionDialog(val){
      this.permissionDialog = false
      if(val) {
        this.showSuccessMessage = true;
        this.showSuccess = false;
      }
    },
    editItem() {
      if (this.selected.length > 1) {
        this.snackbar = true;
      } else {
        // this.editedIndex = this.desserts.indexOf();
        this.editedItem = Object.assign({});
        this.dialog = true;
        this.editedItem = this.selected[0];
      }
    },
    close(val) {
      if (!val) {
        this.selectedPermission = null;
        this.dialog = false;
      } else {
        this.selectedPermission = null;
        this.dialog = false;
        this.showSuccess = true;
      }
    },
    async save() {
      // if (this.editedIndex > -1) {
      this.disableSave = true
      this.loading = true
      const update = await this.updatePermission(this.editedItem);
      if (update.error) {
        this.disableSave = false
        this.loading = false
        if (update.status == 400) this.errorMessage = update.message;
        else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Internal Server Error",
          });
        }
      } else if (update) {
        this.disableSave = false
        this.loading = false
        this.showSuccess = true;
        this.showSuccessMessage = false;
        this.name = "";
        this.location = "";
        this.dialog = false;
        this.errorMessage = null;
        this.selected = [];
        this.close();
      }
      // }
    },
    deleteItem() {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, cancel!",
        reverseButtons: true,
      }).then((result) => {
        let selectedItems = [];
        for (let i = 0; i < this.selected.length; i++) {
          selectedItems.push(this.selected[i].id);
        }
        if (result.isConfirmed) {
          this.loading = true;
          this.deletePermission(selectedItems).then(() => {
            this.loading = false;
            Swal.fire("Deleted!", "Your file has been deleted.", "success");
            this.selected = []
          });
        }
      });
    }
  },
  computed: mapGetters(["allPermissions", "totalPermissionsCount"]),
  watch: {
    tableDisplay() {
      if(this.tableDisplay == 'permissions') {
        this.showSuccessMessage = false
        this.showSuccess = false
        if(this.fetchOnce) {
          if(this.allPermissions.length == 0)
            this.isFetching = true;
          this.fetchPermissions({ itemsPerPage: 0 }).then(() => {
            this.isFetching = false;
          });
          this.fetchOnce = false;
        }
      }
    }
  }
};
</script>

<style>
</style>